import React from "react";
export var MakroAlertType;
(function (MakroAlertType) {
    MakroAlertType[MakroAlertType["SUCCESS"] = 0] = "SUCCESS";
    MakroAlertType[MakroAlertType["INFO"] = 1] = "INFO";
    MakroAlertType[MakroAlertType["WARNING"] = 2] = "WARNING";
    MakroAlertType[MakroAlertType["DANGER"] = 3] = "DANGER";
})(MakroAlertType || (MakroAlertType = {}));
var MakroAlert = function MakroAlert(_ref) {
    var type = _ref.type, title = _ref.title, text = _ref.text;
    var color = function color(type) {
        switch (type) {
            case MakroAlertType.SUCCESS:
                return "bg-green-100 border-green-500 text-green-700";
            case MakroAlertType.WARNING:
                return "bg-orange-100 border-orange-500 text-orange-700";
            case MakroAlertType.DANGER:
                return "bg-red-100 border-red-500 text-red-700";
            case MakroAlertType.INFO:
            default:
                return "bg-blue-100 border-blue-500 text-blue-700";
        }
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: "border-l-4 p-4 " + color(type),
        role: "alert"
    }, title && /*#__PURE__*/ React.createElement("p", {
        className: "font-bold"
    }, title), text && /*#__PURE__*/ React.createElement("p", null, text));
};
export default MakroAlert;
